import script from "./TimeIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./TimeIndicator.vue?vue&type=style&index=0&id=406e3423&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406e3423"]])

export default __exports__